import React, { FC, useState } from "react";
import { NavArrowDownIcon } from "assets/svgs";
import clsx from "clsx";
import { css } from "@emotion/css";
import { Theme } from "evcharging/app/themes";
import useTheme from "evcharging/hooks/useTheme";
import useI18n from "evcharging/hooks/useI18n";

interface NavLinkDropdownProps {
  label: string;
  links: Array<{
    href: string;
    label: string;
    onClick?: () => void;
  }>;
}

const NavLinkDropdownMobile: FC<NavLinkDropdownProps> = (props) => {
  const { t } = useI18n();
  const { label, links } = props;
  const [showMore, setShowMore] = useState<boolean>(false);
  const toggleMenu = () => setShowMore((prevState) => !prevState);

  const theme = useTheme();
  const classes = createStyles(theme);

  return (
    <div onClick={toggleMenu} style={{position:"relative"}}>
      <p className={clsx(classes.dropdownLink, classes.isLink)}>
        {label}
        <NavArrowDownIcon className={clsx(classes.showMoreIcon, showMore && classes.rotateIcon)} />
      </p>
      <div style={{display: showMore ? 'block' : 'none'}}>
        <div className={classes.dropDownList}>
          {links.map((link) => (
            <a
              href={link.href}
              aria-label={link.label}
              className={classes.link}
              onClick={link.onClick}
            >
              {t(link.label)}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

const createStyles = (theme: Theme) => ({
  dropdownLink: css({
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    transition: "all 300ms",
    color: '#fff',
  }),
  isLink: css({
    color: '#fff',
    fontWeight: 600,
    fontSize: "16px !important",
    margin: `15px !important`,
    "& svg": {
      marginLeft: theme.spacing(2),
      marginTop: 3,
      "& path": {
        fill: '#fff',
      }
    }
  }),
  dropDownList: css({
    display: "flex",
    flexDirection: "column",
    margin: theme.spacing(2, 3, 0, 5)
  }),
  link: css({
    color: '#fff',
    fontWeight: 400,
    fontSize: 16,
    marginBottom: theme.spacing(3)
  }),
  showMoreIcon: css({
    transition: "all 200ms"
  }),
  rotateIcon: css({
    transform: "rotate(-180deg)"
  }),
  dropdownLabel: css({
    fontSize: 18,
    "&:hover": {
      textDecoration: "underline"
    }
  })
});

export default NavLinkDropdownMobile;
